import { Coverage } from '@sky-distribution/adapter-core-pc-rest-interfaces';

export const createCoveragesMap = (
  coverages?: Coverage[],
) => coverages?.reduce((acc, curr) => {
  acc.set(curr.codeIdentifier, curr);

  return acc;
}, new Map()) ?? new Map();

const getCoverageDetails = ({
  codeIdentifier,
  selected,
  terms,
}: {
  codeIdentifier: string;
  selected: boolean;
  terms: Coverage['terms'];
},
retrievedCoverages: Map<string, Coverage>): Partial<Coverage> => {
  const retrievedCoverage = retrievedCoverages.get(codeIdentifier);
  const isNumericTermValue = !!Number(terms?.[0]?.chosenTermValue);
  const shouldRetrieveTerms = retrievedCoverage?.selected && !isNumericTermValue;

  return {
    codeIdentifier,
    selected: retrievedCoverage?.selected ?? selected,
    amount: retrievedCoverage?.amount,
    terms: shouldRetrieveTerms ? retrievedCoverage?.terms : terms,
  };
};

export const getDefaultCoverages = (coverages?: Coverage[]): Coverage[] => {
  const retrievedCoverages = createCoveragesMap(coverages);

  return [
    {
      codeIdentifier: 'HOHCivilPersonalLiability',
      selected: false,
      terms: [
        {
          chosenTermValue: 'CPLSumInsuredBasicpln',
          patternCode: 'HOHCivilPersonalLiabilityCPLSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHHomeAssistance',
      selected: false,
      terms: [
        {
          chosenTermValue: 'Basic',
          patternCode: 'HASumInsured',
        },
      ],
    },
  ].map((defaultCoverage) => getCoverageDetails(defaultCoverage, retrievedCoverages));
};

export const getDefaultDwellingCoverages = (
  propertyValue: string,
  movablesValue: string,
  dwellingCoverages?: Coverage[],
): Coverage[] => {
  const retrievedCoverages = createCoveragesMap(dwellingCoverages);

  return [
    {
      codeIdentifier: 'HOHWalls',
      selected: true,
      terms: [
        {
          chosenTermValue: propertyValue,
          patternCode: 'HOHWallsSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHMovables',
      selected: false,
      terms: [
        {
          chosenTermValue: movablesValue,
          patternCode: 'HOHMovablesSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHGlass',
      selected: false,
      terms: [
        {
          chosenTermValue: 'GlassSumInsuredBasicpln',
          patternCode: 'HOHGlassGlassSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHMovablesFlood',
      selected: false,
      terms: [
        {
          chosenTermValue: movablesValue,
          patternCode: 'HOHMovablesFloodMovablesFloodSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHMovablesOvervoltage',
      selected: false,
      terms: [
        {
          chosenTermValue: movablesValue,
          patternCode: 'HOHMovablesOvervoltageMovablesOvervoltageSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHMovablesTheft',
      selected: false,
      terms: [
        {
          chosenTermValue: movablesValue,
          patternCode: 'HOHMovablesTheftMovablesTheftSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHWallsFlood',
      selected: true,
      terms: [
        {
          chosenTermValue: propertyValue,
          patternCode: 'HOHWallsFloodWallsFloodSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHWallsOvervoltage',
      selected: true,
      terms: [
        {
          chosenTermValue: propertyValue,
          patternCode: 'HOHWallsOvervoltageWallsOvervoltageSumInsured',
        },
      ],
    },
    {
      codeIdentifier: 'HOHWallsTheft',
      selected: false,
      terms: [
        {
          chosenTermValue: movablesValue,
          patternCode: 'HOHWallsTheftWallsTheftSumInsured',
        },
      ],
    },
  ].map((defaultCoverage) => getCoverageDetails(defaultCoverage, retrievedCoverages));
};
